import { cardSlotOf } from './uploadedMediaCard';

import type { UploadedMediaCardType } from './uploadedMediaCard';
import type { CompositionTemplate } from '@src/components/sidepanel/CompositionSettings/types';

/**
 * PLAT-11732 — the cards already on the timeline that fill a slot, so adding a
 * new intro / end card can take the old one off first: a video has one intro
 * and one end card at a time.
 *
 * Read from each element's stored template meta (`storeCompositionTemplateMetadata`),
 * with the same type-or-placement rule `cardSlotOf` uses for designs.
 */
export function cardSlotElementIds(
  extraElementData: Record<string, unknown> | undefined,
  timelineElementIds: Iterable<string>,
  slot: UploadedMediaCardType,
): string[] {
  if (!extraElementData) return [];
  const ids: string[] = [];
  for (const id of timelineElementIds) {
    const meta = extraElementData[id];
    if (!meta || typeof meta !== 'object') continue;
    const { compositionType, placement } = meta as Partial<
      Pick<CompositionTemplate, 'compositionType' | 'placement'>
    >;
    if (cardSlotOf({ compositionType: compositionType!, placement }) === slot)
      ids.push(id);
  }
  return ids;
}
